import { render, staticRenderFns } from "./Pedido_Item.vue?vue&type=template&id=6e10b3a8&"
import script from "./Pedido_Item.vue?vue&type=script&lang=js&"
export * from "./Pedido_Item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../cliente-cocina/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports